// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "37541ce7" + "." + "f63bbdef98f9e5ab" + ".js";
};